/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'pip-analytics__messaging',
    'window'
],
function(
    pip,
    pipEvents,
    pipAnalyticsMessaging,
    window
){

	function initEventListeners(){

		pipEvents.shippingOptions.shippingOptionsZipCodeWasChecked.on('.shippingOptionsZipCodeWasChecked', function(){
		    var eventObject = pipAnalyticsMessaging.events.shippingOptions.checkZipSuccess;
            eventObject.item[0].productInfo.sku = pip.products.primary.data.itemId;
            eventObject.item[0].fulfillment.zip = pip.customer.dynamicEtaZipCode;

            var shipMode = (pip.fulfillment
                && pip.fulfillment.shipping
                && pip.fulfillment.shipping.shippingServiceResponse
                && pip.fulfillment.shipping.shippingServiceResponse
                && pip.fulfillment.shipping.shippingServiceResponse.items
                && pip.fulfillment.shipping.shippingServiceResponse.items[0]
                && pip.fulfillment.shipping.shippingServiceResponse.items[0].deliveries
                && pip.fulfillment.shipping.shippingServiceResponse.items[0].deliveries[0]
                && pip.fulfillment.shipping.shippingServiceResponse.items[0].deliveries[0].shipModes
                && pip.fulfillment.shipping.shippingServiceResponse.items[0].deliveries[0].shipModes[0]);

            if(shipMode) {
                eventObject.item[0].productInfo.eta = {
                    sthStartDate: shipMode.estArrivalStartDate,
                    sthEndDate: shipMode.estArrivalEndDate || shipMode.estArrivalStartDate
                };
            }

            window.digitalData.event.push(eventObject);

            pip.debugMode && console.log('DDO Shipping Event', eventObject);
		});

		pipEvents.shippingOptions.shippingOptionsZipCodeCheckError.on('.shippingOptionsZipCodeCheckError', function(){
			window.digitalData.event.push(pipAnalyticsMessaging.events.shippingOptions.checkZipError);
            pip.debugMode && console.log('DDO Shipping Event', pipAnalyticsMessaging.events.shippingOptions.checkZipError);
		});
	}

	return {
		init: function(){
			initEventListeners();
		}
	}

});

}.call(window));